/* MB sections: slider, countdown, video play, bundle picker. Idempotent; re-inits in theme editor. */
(function () {
  if (window.__mbInit) return;
  window.__mbInit = true;

  function initSlider(root) {
    if (!root || root.__mb) return;
    var track = root.querySelector('[data-mb-track]');
    if (!track) return;
    root.__mb = true;
    var prev = root.querySelectorAll('[data-mb-prev]');
    var next = root.querySelectorAll('[data-mb-next]');
    var dots = root.querySelector('[data-mb-dots]');
    var items = function () { return Array.prototype.slice.call(track.children); };
    function step() {
      var f = items()[0]; if (!f) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return f.getBoundingClientRect().width + gap;
    }
    function pages() {
      if (track.scrollWidth <= track.clientWidth + 2) return 1;
      var vis = Math.max(1, Math.round((track.clientWidth + 1) / step()));
      return Math.max(1, items().length - vis + 1);
    }
    function idx() { return Math.min(Math.round(track.scrollLeft / step()), pages() - 1); }
    function update() {
      var i = idx();
      if (dots) Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-active', k === i); });
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.forEach(function (b) { b.disabled = track.scrollLeft <= 2; });
      next.forEach(function (b) { b.disabled = track.scrollLeft >= max; });
    }
    function build() {
      if (dots) {
        dots.innerHTML = '';
        var n = pages();
        if (n > 1) for (var i = 0; i < n; i++) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'mb-dot'; b.setAttribute('aria-label', 'Slide ' + (i + 1));
          (function (k) { b.addEventListener('click', function () { track.scrollTo({ left: k * step(), behavior: 'smooth' }); }); })(i);
          dots.appendChild(b);
        }
      }
      update();
    }
    prev.forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); }); });
    next.forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); }); });
    var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(update, 60); }, { passive: true });
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(build, 150); });
    build();
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function initTimer(root) {
    if (!root || root.__mb) return; root.__mb = true;
    var h = root.querySelector('[data-h]'), m = root.querySelector('[data-m]'), s = root.querySelector('[data-s]');
    var hours = parseInt(root.getAttribute('data-hours') || '24', 10);
    function tick() {
      var now = new Date(), end;
      if (hours >= 24) { end = new Date(now); end.setHours(24, 0, 0, 0); }
      else { var ms = hours * 3600000; end = new Date(Math.ceil(now.getTime() / ms) * ms); }
      var d = Math.max(0, Math.floor((end - now) / 1000));
      h.textContent = pad(Math.floor(d / 3600)); m.textContent = pad(Math.floor(d % 3600 / 60)); s.textContent = pad(d % 60);
    }
    tick(); setInterval(tick, 1000);
  }

  function initVideo(root) {
    if (!root || root.__mb) return; root.__mb = true;
    var v = root.querySelector('video'), b = root.querySelector('.mb-vid__play');
    if (!v || !b) return;
    b.addEventListener('click', function () { v.controls = true; v.play(); root.classList.add('is-playing'); });
  }

  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.'); var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    fmt = fmt || '${{amount}}';
    return fmt.replace(/\{\{\s*amount\s*\}\}/, whole + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, whole.replace(/,/g, '.') + ',' + parts[1]);
  }
  function initBundle(root) {
    if (!root || root.__mb) return; root.__mb = true;
    var qty = root.querySelector('input[name="quantity"]');
    var opts = root.querySelectorAll('.mb-bundle__opt');
    var btnSel = root.getAttribute('data-atc');
    var fmt = root.getAttribute('data-money');
    function apply(opt) {
      opts.forEach(function (o) { o.classList.toggle('is-selected', o === opt); });
      var r = opt.querySelector('input[type=radio]'); if (r) r.checked = true;
      if (qty) qty.value = opt.getAttribute('data-qty');
      var label = root.getAttribute('data-atc-label');
      var btn = btnSel && document.querySelector(btnSel);
      if (btn && label) {
        var span = btn.querySelector('span') || btn;
        var txt = label.replace('[price]', money(+opt.getAttribute('data-total'), fmt));
        btn.setAttribute('data-mb-label', txt);
        span.textContent = txt;
      }
    }
    opts.forEach(function (o) { o.addEventListener('click', function () { apply(o); }); });
    var sel = root.querySelector('.mb-bundle__opt.is-selected') || opts[0];
    if (sel) apply(sel);
  }

  function initAtcLabel(btn) {
    if (!btn || btn.__mbLbl) return; btn.__mbLbl = true;
    var span = btn.querySelector('span'); if (!span) return;
    new MutationObserver(function () {
      var want = btn.getAttribute('data-mb-label');
      var def = window.variantStrings && window.variantStrings.addToCart;
      if (want && def && span.textContent.trim() === def.trim() && !btn.disabled) span.textContent = want;
    }).observe(span, { childList: true, characterData: true, subtree: true });
  }

  function initAll(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-mb-slider]').forEach(initSlider);
    scope.querySelectorAll('[data-mb-timer]').forEach(initTimer);
    scope.querySelectorAll('.mb-vid').forEach(initVideo);
    scope.querySelectorAll('[data-mb-bundle]').forEach(initBundle);
    scope.querySelectorAll('.product-form__submit[data-mb-label]').forEach(initAtcLabel);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
